import { GlassCard } from "../components/GlassCard";
import { MetricCard } from "../components/MetricCard";

export interface DetailMetric {
  title: string;
  value: string;
  detail?: string;
}

export interface DetailField {
  label: string;
  value: string;
}

export interface DetailGridItem {
  eyebrow?: string;
  title: string;
  description?: string;
  fields?: DetailField[];
}

export function DetailMetricGrid({ items }: { items: DetailMetric[] }) {
  return (
    <div className="metrics-grid">
      {items.map((item) => (
        <MetricCard key={item.title} title={item.title} value={item.value} detail={item.detail} />
      ))}
    </div>
  );
}

export function DetailCardGrid({ items }: { items: DetailGridItem[] }) {
  return (
    <div className="grid-two">
      {items.map((item) => (
        <GlassCard key={`${item.eyebrow ?? "detail"}-${item.title}`} className="stack-md">
          {item.eyebrow ? <span className="card-eyebrow">{item.eyebrow}</span> : null}
          <div className="stack-xs">
            <h3 className="card-title">{item.title}</h3>
            {item.description ? <p className="card-copy">{item.description}</p> : null}
          </div>
          {item.fields?.length ? (
            <div className="status-meta-list">
              {item.fields.map((field) => (
                <div key={`${item.title}-${field.label}`} className="status-meta-row">
                  <span className="status-meta-label">{field.label}</span>
                  <strong className="status-meta-value">{field.value}</strong>
                </div>
              ))}
            </div>
          ) : null}
        </GlassCard>
      ))}
    </div>
  );
}

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0
  }).format(value);
}
